import React, { createContext, useContext, useState, useCallback } from 'react';

const EligibilityModalContext = createContext(null);

export const EligibilityModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState(null);

  const open = useCallback((src = null) => {
    setSource(src);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  return (
    <EligibilityModalContext.Provider value={{ isOpen, source, open, close }}>
      {children}
    </EligibilityModalContext.Provider>
  );
};

export const useEligibilityModal = () => {
  const ctx = useContext(EligibilityModalContext);
  if (!ctx) throw new Error('useEligibilityModal must be used inside EligibilityModalProvider');
  return ctx;
};
